import React from 'react';
import '../styles/footer.scss';

const links = {
    'Case Studies': '/case-studies/',
    'Blog': '/blog/',
    'Careers': '/careers/',
    'Contact': '/#contact',
}

const Footer = () => {
    return (
        <footer className='footer'>
            <div className='content'>
                <div className='logo'>
                    <img src="/images/54-bit-studios-fist.png" alt="54 Bit Studios" width="399" height="360" loading="lazy" />
                </div>
                <nav className='footer-links' aria-label='Footer'>
                    <ul>
                        {Object.entries(links).map(([label, href]) => (
                            <li key={href}><a href={href}>{label}</a></li>
                        ))}
                    </ul>
                </nav>
                <p className='about'>We're a small team of ecommerce experts who are financially invested in the company. That means no matter if you require coding, SEO, design or conversion rate optimisation - you'll be working with an on-shore professional who cares deeply about delivering beyond your expectations.</p>
            </div>
            <hr></hr>
            <p className='small-print'>54 Bit Studios Ltd is a company registered in England and Wales with registration number 13436200</p>
        </footer>
    )
}

export default Footer